import React from "react";
import { useNavigate } from "react-router-dom";
import OfficerDashboard from "../components/officerDashboard";
import Header from "../components/header";
import dashboardIcon2 from "../assets/images/grid-view2.png";
import logoutIcon from "../assets/images/logout.svg";
import AdminDashboard from "../components/adminDashboard";
import { useAuth } from "../utils/AuthContext";

const AdminDesk = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleSignOut = () => {
    ["email", "name", "userId"].forEach((key) => sessionStorage.removeItem(key));
    logout();
    navigate("/");
  };

  return (
    <div className="flex flex-col h-[100dvh] overflow-hidden">
      <Header />
      {/* <AdminDashboard /> */}

      <div className="flex-1 flex flex-col sm:flex-row overflow-hidden">
        {/* Mobile Top Navigation */}
        <div className="flex sm:hidden w-full bg-page-bg border-b border-cream px-4 py-2 gap-3 justify-between overflow-x-auto shrink-0">
          <div className="flex items-center gap-2 px-3 py-2 rounded-lg text-xs font-semibold shrink-0 whitespace-nowrap bg-brand-teal text-white">
            <img src={dashboardIcon2} alt="" className="w-4 h-4" />
            Dashboard
          </div>
          <button
            className="flex items-center gap-2 px-3 py-2 rounded-lg text-xs font-bold shrink-0 whitespace-nowrap bg-[#4a0e1e] hover:bg-[#9c2942] text-white border border-[#4a0e1e] transition-all duration-200 hover:scale-[1.02] shadow-sm cursor-pointer"
            onClick={() => navigate("/registerOfficer")}
          >
            Register Officer
          </button>

        </div>

        {/* Desktop Sidebar */}
        <aside className="hidden sm:flex w-[15%] min-w-[150px] flex-col items-center text-white gap-y-2 pt-4 shadow-lg bg-page-bg shrink-0">
          <div className="mt-1 w-[95%] h-[40px] text-[14px] xl:text-[15px] rounded-lg flex items-center justify-center gap-x-3 px-2 font-semibold cursor-pointer shadow bg-brand-teal text-white whitespace-nowrap">
            <div className="w-[18px] h-[18px] overflow-hidden">
              <img src={dashboardIcon2} alt="dashboard" className="w-full h-full object-cover" />
            </div>
            Dashboard
          </div>
          <div
            className="mt-1 w-[95%] h-[40px] text-[14px] xl:text-[15px] rounded-lg flex items-center justify-center gap-x-3 px-2 font-bold cursor-pointer bg-[#4a0e1e] hover:bg-[#9c2942] text-white transition-all duration-200 hover:scale-[1.02] whitespace-nowrap shadow-md"
            onClick={() => navigate("/registerOfficer")}
          >
            <span>Register Officer</span>
          </div>
          <div className="mt-auto w-full flex flex-col items-center">
            <button
              onClick={handleSignOut}
              className="w-[95%] mb-4 py-[10px] px-3 rounded-[8px] font-[700] text-[14px] text-[#9c2942] bg-[#f7eef0] border-[1.5px] border-[#9c2942] hover:bg-[#9c2942] hover:text-white transition-all duration-200 cursor-pointer flex items-center justify-center gap-2 whitespace-nowrap shadow-sm"
            >
              <i className="fa-solid fa-arrow-right-from-bracket w-[16px] text-center"></i>
              Logout
            </button>
          </div>
        </aside>
        <main className="flex-1 overflow-y-auto">
          <AdminDashboard />
        </main>
      </div>

    </div>
  );
};

export default AdminDesk;
